<div class="edit-user" mat-dialog-content>
    <!--    FUNCTION IN TEMPLATE-->
    <h2 mat-dialog-title class="title">{{ data.user.email + ("editUser.title" | translate) }}</h2>
    <app-button
        [buttonType]="'secondary'"
        [leftIcon]="'mail'"
        [label]="'editUser.mfa.button' | translate"
        class="mfa-button"
        (clickEmitter)="resetMfa()"
    ></app-button>
    <app-button
        [buttonType]="'secondary'"
        [label]="(data.user.blocked ? 'editUser.unblock.button' : 'editUser.block.button') | translate"
        class="block-button"
        (clickEmitter)="toggleBlock()"
    ></app-button>
    <mat-form-field appearance="fill">
        <mat-label>{{ 'editUser.roles.title' | translate }}</mat-label>
        <mat-select [formControl]="rolesControl">
            @for (role of allRoleNames; track role) {
                <mat-option [value]="role">{{ role }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    @if (showScopeSelect) {
        <mat-form-field appearance="fill">
            <mat-label>{{ 'editUser.scopes.title' | translate }}</mat-label>
            <mat-select [formControl]="scopesControl" multiple>
                @for (scope of allScopes; track scope) {
                    <mat-option [value]="scope.name">{{ scope.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    }
    <app-button
        class="close-button"
        [buttonType]="'primary'"
        [label]="'buttons.close' | translate"
        (clickEmitter)="closeDialog()"
    ></app-button>
</div>
